module.exports = {

    indent: 4

};
